import { QueryFunctionContext } from 'react-query'
import request from 'services/axios'

export const setCommissionPlan = async (payload: number) => {
    const { data } = await request.post(
        `/api/v1/general/switch-to-commission/`,
        {
            box_type: 'mnp',
            box_id: payload,
        }
    )
    return data
}
export const initSubscription = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IInitTransactionWallet } = await request.post(
        `/api/v1/payment/init/?os_type=android&app_version=1.892.9`,

        [
            {
                id: ctx.queryKey[1],
                type: 'mbr',
                amount: 0,
                cashin_type: 'hwt',
                paid_obj_id: 0,
            },
        ]
    )
    return data
}

export const setSubscriptionPayment = async (
    payload: ISetSubscriptionPaymentPayload
) => {
    const { data }: { data: ISubscriptionPlanResult } = await request.post(
        `/api/v1/payment/orders/`,

        {
            transaction: {
                gateway: payload.gateway,
                is_group_pay: false,
                payer_name: '',
                receiver_name: '',
                source: 'gtw',
                state: '',
                state_time: '',
                transaction_code: '',
            },
            service_package: 1,
            month_count: payload.monthCount,
            ctx_id: payload.ctxId,
            ctx_type: 'mnp',
            os_type: 'android',
            app_version: '1.892.9',
        }
    )
    return data
}
